import { useQuery } from '@tanstack/react-query';
import { ApiEndPoints, QueryKey } from '@constants';
import { httpRequest } from '@lib';

async function fetchClientMetaData() {
  const { data } = await httpRequest.get(ApiEndPoints.FETCH_CLIENT_META_DATA);
  return data;
}

export function useFetchClientMetaDataQuery() {
  // Tenant branding doesn't change within a session. Fetch it once and serve
  // it from cache on every later dashboard mount (route changes, profile
  // switches) instead of refetching each time.
  return useQuery({
    queryKey: [QueryKey.EUP_CLIENT_META_DATA],
    queryFn: fetchClientMetaData,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
